import { render, staticRenderFns } from "./DashboardConfirmEmailModal.vue?vue&type=template&id=23c98d0d&scoped=true&"
import script from "./DashboardConfirmEmailModal.vue?vue&type=script&lang=js&"
export * from "./DashboardConfirmEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardConfirmEmailModal.vue?vue&type=style&index=0&id=23c98d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c98d0d",
  null
  
)

export default component.exports